





































import { Component, Vue } from "vue-property-decorator";
import Router from "@/router";
import Home from "./views/Home.vue";

@Component({
  components: {
    Home
  }
})
export default class App extends Vue {
  private appTitle = "bjorndaniel.se";

  home(): void {
    Router.push({ name: "Home" });
  }
}
